import { useState, useEffect } from "react";
import { Outlet, Link, useLoaderData, NavLink } from "react-router-dom";
import Select from 'react-select'
// import "antd/dist/antd.css";
import { Table } from "antd";
import { CSVLink } from "react-csv";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import Spinner from './Spinner';

import * as API from "../services/listados";
import * as APIESPECIALISTAS from "../services/especialistas";

export async function loader() {
  // const pacientes = await API.getAllPacientes();
  // return { pacientes };
}

export function ListadoAdminItem() {
  // const { pacientes } = useLoaderData();
  const [listadoFechaIni, setListadoFechaIni] = useState("");
  const [listadoFechaFin, setListadoFechaFin] = useState("");
  const [listadoFechaIniTrat, setListadoFechaIniTrat] = useState("");
  const [listadoFechaFinTrat, setListadoFechaFinTrat] = useState("");
  const [listadoTipoCont, setListadoTipoCont] = useState(null);
  let listadoTipoContString = listadoTipoCont?.value || ''; // Obtén el valor de 'value' del objeto

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Data');


  const [loading, setLoading] = useState(false);
  const [especialistas, setEspecialistas] = useState([]);
  const [especialistasListSelect, setEspecialistasListSelect] = useState([]);
  const [listadoEspecialistas, setListadoEspecialistas] = useState("");
  let listadoEspecialistasString = Array.prototype.map.call(listadoEspecialistas, s => s.value).toString();

  const [listadoResult, setListadoResult] = useState("");
  const [columns, setColumns] = useState([]);
  const [columnsExcel, setColumnsExcel] = useState([]);
  const [listadoResultSinSaltosDeLinea, setListadoResultSinSaltosDeLinea] = useState("");
  console.log(listadoResultSinSaltosDeLinea)

  // 1.Load all Especialistas
  useEffect(() => {
    const loadEspecialistas = async () => {
      setLoading(true);
      try {
        const response = await APIESPECIALISTAS.getAllEspecialistas();
        setEspecialistas(response);
      } catch (error) {
        console.error('Error al cargar los especialistas:', error);
      } finally {
        setLoading(false);
      }
    };

    loadEspecialistas();
  }, []);

  // 2.Map all Especialistas to create the options for multiselect
  useEffect(() => {
    const options = especialistas.map((field) => ({
      value: field.id,
      label: field.display_name,
    }));

    // Agregar opción "Seleccionar Todos"
    const selectAllOption = { value: 'selectAll', label: 'Seleccionar Todos' };
    const finalOptions = [selectAllOption, ...options];
    setEspecialistasListSelect(finalOptions);
  }, [especialistas]);

  const handleChange = (selectedOption) => {
    // Si se selecciona "Seleccionar Todos", seleccionar todas las opciones
    if (selectedOption && selectedOption.some(option => option.value === 'selectAll')) {
      setListadoEspecialistas(especialistasListSelect.filter(option => option.value !== 'selectAll'));
    }
    // Si se selecciona cualquier otra opción, manejar la selección normalmente
    else {
      setListadoEspecialistas(selectedOption);
    }
  };

  const listadoTipoContOpt = [
    { value: "vismedicas", label: "Visitas Médicas" },
    { value: "vispsicolog", label: "Visitas Psicológicas" },
    { value: "mindfulness", label: "Mindfulness" },
    { value: "nutricion", label: "Nutricion" },
    { value: "psicoterapia", label: "Psicoterapia" },
    { value: "entrenamiento", label: "Entrenamiento" },
    { value: "mindfulness", label: "Mindfulness" },
    { value: "nutricion", label: "Nutricion" },
  ];

  const listadoTipoMedicina = [
    { value: "antmedicos", label: "Antecedentes Médicos" },
    { value: "explmedica", label: "Exploración Médica" },
    { value: "conspretrat", label: "Consulta Pre-Tratamiento" },
    { value: "vismedicas", label: "Visita Médica" },
    { value: "conspostrat", label: "Consulta Post-Tratamiento" },
    { value: "analiticas", label: "Analíticas" },
  ];
  const listadoTipoPsicologia = [
    { value: "entmotivacional", label: "Entrevista Motivacional" },
    { value: "antpsicologicos", label: "Antecedentes Psicológicos" },
    { value: "datconsumo", label: "Datos de Consumo" },
    { value: "conspretrat", label: "Consulta Pre-Tratamiento" },
    { value: "vispsicolog", label: "Visita Psicológica" },
    { value: "conspostrat", label: "Consulta Post-Tratamiento" },
    { value: "psicoterapia", label: "Sesión Psicoterapia" },
  ];
  const listadoTipoNutricion = [
    { value: "nutricion", label: "Nutricion" },
  ];
  const listadoTipoEntrenamiento = [
    { value: "entrenamiento", label: "Entrenamiento" },
  ];
  const listadoTipoMindfulness = [
    { value: "mindfulness", label: "Mindfulness" },
  ];

  const listadoTipoCuestionarios = [
    { value: "scl90v", label: "SCL-90-R" },
    { value: "psqi", label: "PSQI" },
    { value: "audit", label: "AUDIT" },
    { value: "who5", label: "WHO-5" },
  ];

  const groupedOptions = [
    {
      label: "Medicina",
      options: listadoTipoMedicina
    },
    {
      label: "Psicoterapia",
      options: listadoTipoPsicologia
    },
    {
      label: "Nutricion",
      options: listadoTipoNutricion
    },
    {
      label: "Entrenamiento",
      options: listadoTipoEntrenamiento
    },
    {
      label: "Mindfulness",
      options: listadoTipoMindfulness
    },
    {
      label: "Cuestionarios",
      options: listadoTipoCuestionarios
    }
  ];


  const submitListado = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    // Crear variables locales para las fechas a enviar
    let fechaInicio = listadoFechaIni;
    let fechaFin = listadoFechaFin;
  
    // Si listadoFechaIni está vacío, usar listadoFechaIniTrat - 30 días
    if (!fechaInicio && listadoFechaIniTrat) {
      const date = new Date(listadoFechaIniTrat);
      date.setDate(date.getDate() - 30);
      fechaInicio = date.toISOString().split('T')[0]; // Formato YYYY-MM-DD
    }
  
    // Si listadoFechaFin está vacío, usar listadoFechaFinTrat + 30 días
    if (!fechaFin && listadoFechaFinTrat) {
      const date = new Date(listadoFechaFinTrat);
      date.setDate(date.getDate() + 30);
      fechaFin = date.toISOString().split('T')[0];
    }
  
    console.log(
      fechaInicio,
      fechaFin,
      listadoTipoContString,
      listadoEspecialistasString
    );
  
    try {
      await API.getListadoItem(
        fechaInicio,
        fechaFin,
        listadoTipoContString,
        listadoEspecialistasString
      ).then(
        (val) => {
          setListadoResult(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  



  useEffect(() => {
    if (listadoResult.length > 0) {
      // Convertir fechas a formato Date para comparación
      const convertToDate = (dateStr) => {
        if (!dateStr) return null; // Verificar si dateStr está definido y no está vacío
        const [day, month, year] = dateStr.split('/');
        return new Date(`${year}-${month}-${day}`);
      };
  
      // Filtrar los resultados por el rango de fechas del tratamiento
      const filteredResult = listadoResult.filter((objeto) => {
        const tratamientoDate = convertToDate(objeto.Tratamiento);
        const startDate = listadoFechaIniTrat ? new Date(listadoFechaIniTrat) : null;
        const endDate = listadoFechaFinTrat ? new Date(listadoFechaFinTrat) : null;
  
        // Si no hay fecha de tratamiento, no lo incluimos en el resultado filtrado
        if (!tratamientoDate) return false;
  
        // Si ambas fechas están presentes, comprobar si la fecha de Tratamiento está dentro del rango
        if (startDate && endDate) {
          return tratamientoDate >= startDate && tratamientoDate <= endDate;
        }
  
        // Si solo una fecha está presente, comprobar si la fecha de Tratamiento es mayor o igual a la de inicio o menor o igual a la de fin
        if (startDate) {
          return tratamientoDate >= startDate;
        }
  
        if (endDate) {
          return tratamientoDate <= endDate;
        }
  
        return true; // Si no hay fechas, no se aplica filtro
      });
  
      // Continuar con el proceso normal si hay resultados filtrados
      if (filteredResult.length > 0) {
        const keys = Object.keys(filteredResult[0]);
        const newColumns = keys.map((key) => ({
          title: key,
          dataIndex: key,
          key: key,
        }));
  
        setColumns(newColumns);
  
        const newColumnsExcel = keys.map((key) => ({
          header: key,
          key: key,
          width: 15,
        }));
  
        setColumnsExcel(newColumnsExcel);
  
        const arraySinSaltosDeLinea = filteredResult.map((objeto) => {
          if (objeto.Observaciones !== undefined) {
            return {
              ...objeto,
              Observaciones: objeto.Observaciones.replace(/\n/g, ''),
            };
          } else {
            return objeto;
          }
        });
  
        setListadoResultSinSaltosDeLinea(arraySinSaltosDeLinea);
      } else {
        // Si no hay resultados, puedes limpiar o manejar la tabla vacía
        setListadoResultSinSaltosDeLinea([]);
        setColumns([]);
        setColumnsExcel([]);
      }
    }
  }, [listadoResult, listadoFechaIniTrat, listadoFechaFinTrat]); // Asegúrate de que el efecto se ejecute si cambian las fechas.
  
  

  const convertToDate = (dateStr) => {
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`);
  };

  // Función para exportar a Excel
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');

    // Añadir las columnas al archivo Excel (asumiendo que columnsExcel es el estado que contiene las columnas)
    worksheet.columns = columnsExcel;

    listadoResultSinSaltosDeLinea.forEach(objeto => {
      const newObj = { ...objeto };
      if (newObj.Tratamiento) {
        newObj.Tratamiento = convertToDate(newObj.Tratamiento);
      }
      if (newObj.Fecha) {
        newObj.Fecha = convertToDate(newObj.Fecha);
      }
      worksheet.addRow(newObj);
    });

    worksheet.eachRow({ includeEmpty: true }, function(row, rowNumber) {
      row.eachCell({ includeEmpty: true }, function(cell, colNumber) {
        if (columnsExcel[colNumber - 1] && (columnsExcel[colNumber - 1].key === 'Tratamiento' || columnsExcel[colNumber - 1].key === 'Fecha')) {
          cell.numFmt = 'dd/mm/yyyy';
        }
      });
    });

    // Añadir datos al archivo Excel (asumiendo que listadoResult es el estado que contiene los datos)
    // listadoResult.forEach(objeto => {
    //   worksheet.addRow(objeto);
    // });

    // Guardar el archivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'Listado-completo.xlsx');
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitListado}>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='listadoFechaIni'>Fecha Inicio</label>
              <div className='control'>
                <input
                  className='input'
                  id='listadoFechaIni'
                  type='date'
                  value={listadoFechaIni}
                  onChange={(e) => setListadoFechaIni(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='listadoFechaFin'>Fecha Fin</label>
              <div className='control'>
                <input
                  className='input'
                  id='listadoFechaFin'
                  type='date'
                  value={listadoFechaFin}
                  onChange={(e) => setListadoFechaFin(e.target.value)}
                />
              </div>
            </div>

            <div className='field'>
              <label htmlFor='listadoFechaIniTrat'>Fecha Inicio Tratamiento</label>
              <div className='control'>
                <input
                  className='input'
                  id='listadoFechaIniTrat'
                  type='date'
                  value={listadoFechaIniTrat}
                  onChange={(e) => setListadoFechaIniTrat(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='listadoFechaFinTrat'>Fecha Fin Tratamiento</label>
              <div className='control'>
                <input
                  className='input'
                  id='listadoFechaFinTrat'
                  type='date'
                  value={listadoFechaFinTrat}
                  onChange={(e) => setListadoFechaFinTrat(e.target.value)}
                />
              </div>
            </div>

            <div className='field'>
              <label htmlFor='listadoTipoCont'>Especialidades</label>
              <div className='control'>
                {/* <Select
                  isMulti
                  name="listadoTipoCont"
                  id='listadoTipoCont'
                  options={listadoTipoContOpt}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Seleccionar Tipos de Contenido"
                  onChange={setListadoTipoCont}
                  value={listadoTipoCont}
                /> */}
                <Select
                isRequired
                  name="listadoTipoCont"
                  required
                  id='listadoTipoCont'
                  options={groupedOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Seleccionar Tipos de Contenido"
                  onChange={setListadoTipoCont}
                  value={listadoTipoCont}
                />
              </div>
            </div>

            <div className='field'>
              <label htmlFor='especialistas'>Especialistas</label>
              <div className='control'>
              <Select
                isMulti
                className='basic-multi-select'
                classNamePrefix='select'
                id='especialistas'
                name='especialistas'
                options={especialistasListSelect}
                placeholder='Seleccionar Especialistas'
                onChange={handleChange}
                value={listadoEspecialistas}
              />
              </div>
            </div>

          </div>

          {loading ? (
                <div className="spinner-container">
                    <Spinner />
                </div>
            ) : (


          listadoResultSinSaltosDeLinea?.length ? (
          <div className="listado-tabla-container">

            {/* <Table dataSource={listadoResult} columns={columns} /> */}
            <Table
              dataSource={listadoResultSinSaltosDeLinea.map((item, index) => ({
                ...item,
                key: index // O utiliza una propiedad única de cada elemento si la tienes
              }))}
              columns={columns}
              scroll={{ x: 'max-content' }}
            />
            <div className="btn-dwnld">
                <CSVLink
                  filename={"Listado-completo.csv"}
                  data={listadoResultSinSaltosDeLinea}
                  className="button is-link"
                  separator={"|"}
                >Descargar CSV</CSVLink>
                <button
                  className="button is-link"
                  onClick={exportToExcel}
                >
                  Descargar XLSX
                </button>
            </div>
          </div>
          ) : (
            <p>
              <i>Sin resultados</i>
            </p>
          )
        )}
        </form>
      </div>
      <div id='actions'>
        <button className='button is-link' form='formNewElement' type='submit'>
          Generar Listado
        </button>
      </div>
    </>
  );
}
